import SpeedRoute from './speed-route.js';
import RouteMarker from '../markers/route-marker.js';

export default class SensorRoute extends SpeedRoute {
    constructor(routeInfo, map, colorIndex, hideIcons, playbackIcon, disableRouteMarkers, fullRouteInfo) {
        super(routeInfo, map, colorIndex, hideIcons, playbackIcon, disableRouteMarkers, fullRouteInfo);
    }

    _paintRouteSensors(sensors = []) {
        for (let sensor of sensors) {
            let sensorMarker = new SensorMarker(sensor, this.route.oid, this.map);
            this.sensorLayer.addLayer(sensorMarker);
        }
        this._makeAddLayerEvent(this.sensorLayer);
    }

    clear(index) {
        this._makeRemoveLayerEvent(this.routeLayer);
        this._makeRemoveLayerEvent(this.markersLayer);
        this._makeRemoveLayerEvent(this.startEndMarkersLayer);
        this._makeRemoveLayerEvent(this.photosLayer);
        this._makeRemoveLayerEvent(this.sensorLayer);
        if (this.playback)
            this.playback.destroy();
        this.deletePhotoMarkers();
        this.arrayOfPhotos = [];
        this._makeClosePhotosWindowEvent();

        this.closePhotosWindow();
        return this.reduceIndex(index);
    };

    _makeMultiOptionsObject() {
        let multiopts = {
            optionIdxFn: (latLng) => {
                return latLng[2] - 1;
            },
            options: [
                { color: 'red' },
                { color: 'orange' },
                { color: 'grey' },
                { color: 'blue' },
                { color: 'green' }
            ]
        };
        return multiopts;
    }

    _createRouteMarker(point) {
        let statusColor = this.alarmColors[point.st - 1];
        return new RouteMarker(this.map, point, this.route.oid, this.allDistance, statusColor);
    }

    _fillCoordsArray(point) {
        this.coordsArray.push([point.lat, point.lon, point.st]);
    }

    reduceIndex(index) {
        return index;
    }
}
